import React from "react";

export default function TextPreviewBody({
  content = "",
  truncated = false,
  variant = "text",
  emptyLabel = "(Leere Datei)",
}) {
  const isSpreadsheet = variant === "spreadsheet";

  return (
    <div className="rounded-xl border border-white/10 bg-white/5 overflow-hidden min-w-0">
      {truncated ? (
        <p className="border-b border-white/10 px-3 py-2 text-xs text-amber-200/90">
          Anzeige wurde gekürzt. Für den vollständigen Inhalt «Download» verwenden.
        </p>
      ) : null}
      {isSpreadsheet ? (
        <div
          className="overflow-x-auto overscroll-x-contain max-w-full"
          data-testid="file-preview-spreadsheet-scroll"
        >
          <pre className="p-3 text-xs sm:text-sm text-blue-100/90 whitespace-pre font-mono min-w-max leading-relaxed">
            {content || emptyLabel}
          </pre>
        </div>
      ) : (
        <pre className="p-3 text-sm text-blue-100/90 whitespace-pre-wrap break-words font-mono leading-relaxed">
          {content || emptyLabel}
        </pre>
      )}
    </div>
  );
}
